export { default } from './ShortFormattedDate';



// WEBPACK FOOTER //
// ./app/components/shared/ShortFormattedDate/index.js